import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHotels = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "2 2 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8893 22.0002H6.11067C3.84453 22.0002 2 20.1565 2 17.8825V6.10905C2 3.84391 3.84453 2.00018 6.11067 2.00018H17.8893C20.1642 2.00018 22 3.84391 22 6.10905V17.8825C22.0088 20.1565 20.1642 22.0002 17.8893 22.0002Z",
			fill: "#EF3346"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.13218 10.8588C9.13218 10.692 9.01803 10.5779 8.85112 10.5779H6.90119C6.7343 10.5779 6.62012 10.692 6.62012 10.8588V12.7991C6.62012 12.9659 6.7343 13.0801 6.90119 13.0801H8.84233C9.00924 13.0801 9.12339 12.9659 9.12339 12.7991V10.8588H9.13218Z",
			fill: "#191E3B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4271 15.1608C13.4271 14.9939 13.3041 14.8798 13.146 14.8798H11.2049C11.038 14.8798 10.9238 14.9939 10.9238 15.1608V17.101C10.9238 17.2679 11.038 17.382 11.2049 17.382H13.146C13.3129 17.382 13.4271 17.2679 13.4271 17.101V15.1608Z",
			fill: "#191E3B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4271 10.8588C13.4271 10.692 13.3129 10.5779 13.146 10.5779H11.2049C11.038 10.5779 10.9238 10.692 10.9238 10.8588V12.7991C10.9238 12.9659 11.038 13.0801 11.2049 13.0801H13.146C13.3129 13.0801 13.4271 12.9659 13.4271 12.7991V10.8588Z",
			fill: "#FDDB32"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4073 6.88151C18.4073 6.17038 17.8364 5.59967 17.1249 5.59967H7.55972C7.36649 5.59967 7.2523 5.66993 7.13812 5.79282L5.21453 7.70679C5.074 7.84725 5.17062 8.06677 5.38142 8.06677H15.9392V18.6199C15.9392 18.8306 16.1499 18.9272 16.2993 18.7867L18.2229 16.8727C18.3459 16.7498 18.4073 16.6357 18.4073 16.4426V6.88151Z",
			fill: "#191E3B"
		})
	]
});
const ForwardRef = forwardRef(SvgHotels);
export { ForwardRef as ReactComponent };
